import { UsersTabV2 } from "@/modules/admin/UsersTabV2";
import { AdminLoading } from "@/modules/admin/AdminLoading";
import { useUpdateHeaderTitle } from "@/hooks/useUpdateHeaderData";
import { useUserMeV2, useUsersV2 } from "@/hooks/useUsersV2";
import { useEffect } from "react";

export default function AdminV2() {
  const { users = [], usersError: usersError, loadingUsers } = useUsersV2();
  const { user, userError, userLoading } = useUserMeV2();

  useEffect(() => {
    document.title = "User Management";
  }, []);

  const error = usersError || userError;

  useUpdateHeaderTitle("User Management");

  if (error) throw new Error(error);

  if (loadingUsers || !user || userLoading) return <AdminLoading />;

  return <UsersTabV2 data={users} />;
}
